import React, { Component } from 'react';
import { Card, message } from 'antd';
import { connect } from 'react-redux';
import { BackBtn } from '@comm/BackBtn';
import { queryBusinessInfo } from '@api/common/business';
import CardBase from './OtherBase';
import TablePayable from './TablePayable';
import PayableStatic from './PayableStatic';
import TableCarry from '../../bill/TableCarry';
import TableCheck from '../../bill/TableCheck';
import TableLog from './TableLog';

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.businessInfo();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.uuid !== this.props.params.uuid) {
      window.location.reload();
    }
  }

  businessInfo = () => {
    queryBusinessInfo({
      businessUuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataInfo: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { dataInfo } = this.state;
    return (
      <div>
        <div className="mb16">
          <BackBtn />
        </div>
        <CardBase dataInfo={dataInfo} loadDetail={this.businessInfo} />
        <Card title="付款约定-账单列表" className="mb16">
          <PayableStatic data={dataInfo} />
          <TablePayable data={dataInfo} />
        </Card>
        <Card title="匹配流水" className="mb16">
          <TableCheck dataSource={dataInfo.incomes} noOp />
        </Card>
        <Card title="结转列表" className="mb16">
          <TableCarry
            dataSource={{
              turns: dataInfo.turns || [],
              oldTurns: dataInfo.oldTurns || [],
            }}
          />
        </Card>
        <Card title="操作日志" className="mb16">
          <TableLog dataSource={[]} noOp businessUuid={dataInfo.businessUuid} />
        </Card>
      </div>
    );
  }
}

export default connect(state => ({ organization: state.organization }))(BaseForm);



// WEBPACK FOOTER //
// ./src/components/incubator/contract/detail/PageOtherDetail.js